import { createContext, useState } from 'react';

export const SidebarContext = createContext({
  open: true,
  toggleSidebar: () => {},
});

export const SidebarProvider = ({ children }: { children: React.ReactNode }) => {
  const [open, setOpen] = useState(true);

  const toggleSidebar = () => setOpen((prev) => !prev);

  return <SidebarContext.Provider value={{ open, toggleSidebar }}>{children}</SidebarContext.Provider>;
};
